export default __webpack_public_path__ + "static/logo__black-3785afea137dcad68f8289a0ca50fb46.png";